import BaseRoutePath from '@Router/baseRoutePathes.enum';

export const getProfilePagePath = (routePrefix: string): string => {
  const output = `/${routePrefix}${BaseRoutePath.PROFILE}`;
  return output;
};
